import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import { TableTopBorder } from 'toolkit/chakra/table';
import { GasPriceInfo } from 'ui/shared/gas/GasPriceInfo';
import Settings from 'ui/snippets/topBar/settings/Settings';

export const BottomActions = () => {
  return (

    <Flex flex={ 1 }>
      <Box
        mt="auto"
        w="full"
        bottom={ 6 }
        overflow="hidden"
        position="sticky"
      >
        <GasPriceInfo/>
        <TableTopBorder my={ 5 } w="100%" ml="0"/>
        <Settings/>
      </Box>
    </Flex>

  );
};
